<template>
  <div class="footerbox">
    <!--  立即报名  -->
    <div class="add">
<!--      <div class="sign">-->
<!--        <div @click="goSign">立即报名</div>-->
<!--        <img src="@/assets/image/righticon.png" class="imgsize" alt="" />-->
<!--      </div>-->
    </div>
    <!--  底部  -->
    <div class="bottom-box">
      <div class="pagew bottom">
        <div class="zhuban-box">
          <div class="stle-box">
            <div class="cont" style="width: 700px">
              <h3>指导单位</h3>
              <div class="logo-img">
<!--              <div class="logo-img"><span>工业和信息化部网络安全产业发展中心（工业和信息化部信息中心）</span>-->
                <span v-for="(content, index) in adviceUnit">{{ content }}</span>
              </div>
            </div>
            <div class="cont" >
              <h3>主办单位</h3>
              <div class="logo-img">
<!--                <span>广东省工业和信息化厅</span><span>珠海市人民政府</span>-->
                <span v-for="(content, index) in mainUnit">{{ content }}</span>
              </div>
            </div>
            <div class="cont" style="width: 300px">
              <h3>承办单位</h3>
              <div class="logo-img">
<!--                <span>珠海市工业和信息化局</span>-->
                <span v-for="(content, index) in supportUnit">{{ content }}</span>
              </div>
            </div>
            <div class="cont" style="width: 265px">
              <h3>特别支持单位</h3>
              <div class="logo-img">
<!--                <span>中国银行广东省分行</span>-->
                <span v-for="(content, index) in specialUnit">{{ content }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="tel">
          <div class="box">
            <div class="boxitem">
              <div class="each">
                <div class="title">大赛组委会秘书处</div>
                <div class="foorter">
                  <div class="user">
                    <div>
                      <!--联系方式-->
                      联系人：{{ contractPersons }}<br><br>
                      电话：{{ contractPhone }}<br><br>
                      E-mail：{{ contractEmail }}<br><br><br>
                      <!--网站技术支持-->
                      网站技术支持：<br><br>
                      {{ serverInfo }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div><img src="@/assets/image/backupimg.png" alt="light">粤公网安备：{{ recordNumberPolice }}   ||   ICP备案：<a href="https://beian.miit.gov.cn/" target="_blank">{{recordNumber}}</a></div><br>
      </div>
    </div>
  </div>
</template>

<script>
import { getFooterInfo, getRecordNumber, getRecordNumberPolice } from "@/api/api.js";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      contractPersons: "", // 组委会联系方式-人员
      contractPhone: "", // 组委会联系方式-电话
      contractEmail: "", // 组委会联系方式-电话
      serverInfo: "", // 技术支持联系方式
      adviceUnit: [], // 指导单位
      mainUnit: [], // 主办单位
      supportUnit: [], // 承办单位
      specialUnit: [], // 特别支持单位
      recordNumber: "", // ICP备案信息
      recordNumberPolice: "" // 粤公安备案信息
    };
  },
  created() {
    this.getFooter();
    this.getRecord();
    this.getRecordPolice()
  },
  methods: {
    goSign() {
      window.location.href = "http://admin.gdsme.org";
      // this.$router.push({
      //   path: "http://admin.gdsme.org",
      // });
    },
    getFooter() {
      getFooterInfo().then(response => {
        let footerInfo = response.data.basiData;
        let info_1 = footerInfo.split("大赛组委会秘书处：");
        let info_2 = info_1[1].split("电话：");
        let info_3 = info_2[1].split("E-mail：");
        let info_4 = info_3[1].split("网站技术支持：");
        let info_5 = info_4[1].split("指导单位：");
        let info_6 = info_5[1].split("主办单位：");
        let info_7 = info_6[1].split("承办单位：");
        let info_8 = info_7[1].split("特别支持单位：");
        this.contractPersons = info_2[0];
        this.contractPhone = info_3[0];
        this.contractEmail = info_4[0];
        this.serverInfo = info_5[0];
        this.adviceUnit = info_6[0].split("；");
        this.mainUnit = info_7[0].split("；");
        this.supportUnit = info_8[0].split("；");
        this.specialUnit = info_8[1].split("；");
      });
    },
    getRecord() {
      getRecordNumber().then(response => {
        this.recordNumber = response.data.basiData;
      });
    },
    getRecordPolice() {
      getRecordNumberPolice().then(response => {
        this.recordNumberPolice = response.data.basiData;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.footerbox {
  margin-top: 30px;
  width: 100%;

  .footer-about {
    width: 100%;
    height: 240px;
    background: url("../../assets/image/back.png") no-repeat;
    background-position: center;

    .title {
      padding: 20px 0;
      font-size: 20px;
      font-weight: bold;
    }

    .content {
      width: 62%;
      margin: 0 auto;
      text-align: left;
      text-indent: 2em;
      line-height: 25px;
    }
  }

  .add {
    width: 100%;
    height: 227px;
    // margin-bottom: 40px;
    background: url("../../assets/image/rightnow.png") no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;

    .sign {
      cursor: pointer;
      position: absolute;
      right: 640px;
      top: 75px;
      width: 200px;
      height: 60px;
      background-color: #ffffff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #044fa6;

      .imgsize {
        width: 15px;
        height: 15px;
        margin: 3px 0 0 20px;
      }
    }
  }

  .bottom {

    .b-cont {
      width: 100%;
      display: flex;

      .cont {
        text-align: left;
        width: 25%;
        font-weight: bold ;
        font-size: 18px;
        padding-bottom: 30px;
      }

      .img {
        display: flex;
        width: 100%;

        .imgbox {
          width: 25%;
        }
      }
    }

    .tel {
      width: 100%;
      margin-top: 20px;
      margin-left: 10px;

      .title {
        text-align: left;
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 20px;
      }

      .box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .boxitem {
          width: 100%;

          .each {
            width: 100%;
            margin-bottom: 20px;

            .title {
              text-align: left;
              font-weight: bold;
              font-size: 18px;
            }

            .foorter {
              .user {
                width: 100%;
                display: flex;
                flex-wrap: wrap;

                div {
                  width: 50%;
                }
              }

              text-align: left;
              display: flex;

              div {
                width: 50%;
              }
            }

            .address {
              text-align: left;
              padding-top: 10px;
              display: flex;
    justify-content: space-between;
            }
          }
        }
      }
    }
  }
}
.bottom-box {
  padding-top: 35px;
  background-color: #f8f5f0;
  .stle-box {
    display: flex;
    font-weight: 700;
    padding-left: 10px;
    font-size: 18px;line-height: 50px;text-align: left;
  }
}
.zhuban-logo {
  display: flex;align-content: center;
  .logo-img {margin-right: 10px;}
}

.beian {
  padding: 5px 0 ;
  font-size: 14px;
  text-align: center;width: 150px;text-align: center;white-space: nowrap;
}
.logo-img span {
  display: inline-block; font-size: 16px;margin-right: 18px;font-weight: normal;
}
.code {
  width: 140px;position: absolute;right: 5px;top: 60px;
}
.bottom {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue